<script setup lang="ts">
import type { ButtonProps } from '#layers/ui/components/Button.vue';
import DButton from '#layers/ui/components/Button.vue';

defineOptions({
	name: 'ButtonDestructive',
	inheritAttrs: false,
});

const {
	variant = 'ghost',
	color = 'neutral',
	// Otherwise both are set to `false` and NuxtLink will detect a conflict
	// eslint-disable-next-line unicorn/no-useless-undefined -- without a default, Vue casts an absent Boolean prop to false
	prefetch = undefined,
	// eslint-disable-next-line unicorn/no-useless-undefined -- without a default, Vue casts an absent Boolean prop to false
	noPrefetch = undefined,
	...forwardedProps
} = defineProps<ButtonProps>();
</script>

<template>
	<DButton
		class="hover:text-error focus-visible:text-error"
		v-bind="{ ...$attrs, ...forwardedProps, variant, color, prefetch, noPrefetch }"
	>
		<slot />
	</DButton>
</template>
